import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FinnairBoundItem, FinnairCabinClass } from '../../api/models';
import { LocationInfoMap } from '../../interfaces';

@Component({
  selector: 'fin-dapi-included-tickets',
  templateUrl: './included-tickets.component.html',
  styleUrls: ['included-tickets.component.scss', '../../assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DapiIncludedTicketsComponent {
  readonly FinnairCabinClass = FinnairCabinClass;

  @Input() locations: LocationInfoMap;
  @Input() bound: FinnairBoundItem;
  @Input() useCabinClass: boolean;
}
